import { render, staticRenderFns } from "./jl.vue?vue&type=template&id=84d80644&scoped=true&"
import script from "./jl.vue?vue&type=script&lang=js&"
export * from "./jl.vue?vue&type=script&lang=js&"
import style0 from "./jl.vue?vue&type=style&index=0&id=84d80644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d80644",
  null
  
)

export default component.exports